import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { BadgePipe } from '../../../pipes/badge.pipe';

@Component({
  selector: 'edt-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatBadgeModule, MatButtonModule, MatIconModule, BadgePipe],
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.css',
  host: {
    '[style.--dynamic-badge-background]': 'badgeColor()',
    '[style.--dynamic-badge-color]': 'badgeTextColor()',
    '[style.--dynamic-icon-background]': 'iconBackgroundColor()',
    '[style.--dynamic-icon-color]': 'iconColor()',
  },
  standalone: true,
})
export class BadgeComponent {
  opened = model<boolean>(false);
  quantity = input<number>(0);
  badgeColor = input<string>('var(--mat-sys-primary)');
  badgeTextColor = input<string>('white');
  iconBackgroundColor = input<string>('transparent');
  iconColor = input<string>('black');
  badgeStyles = input<string>('');
  badgeClasses = input<string>('');
  iconClasses = input<string>('');
  iconStyles = input<string>('');

  triggerButton() {
    this.opened.update(op => !op);
  }
}
